import { CLIENT_DEMAND_TYPE, KYC_PURPOSE } from '@shared/composables/useGlobalConfig'

export const getBusinessPurpose = (demandDetails, demand) => {
  if (demandDetails != null) {
    const demandType =
      demandDetails.type === CLIENT_DEMAND_TYPE.SELLING ? 'Receber valores' : 'Enviar valores'
    if (demandDetails.otherDescription != null)
      return `${demandType} - ${demandDetails.otherDescription}`
    const demandDetail = KYC_PURPOSE[demandDetails.reason]
    return `${demandType} - ${demandDetail}`
  } else if (demand != null) {
    return demand
  }
  return ''
}
